const { is } = require('stdlib/is')

/**
 * Visszaadja egy dátum példányt.
 * @param {string | number | Date} [tmp] - A megadott érték.
 * @returns {Date} A dátum példány.
 */
module.exports.getDateInstance = function getDateInstance (tmp) {
  if (is.nullable(tmp)) {
    return new Date()
  }

  // @ts-expect-error Nem lehet undefined vagy null.
  const date = new Date(tmp)

  return date
}
